/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingIntelligenceTimelineItemResponseEventKind =
    (typeof BuildingIntelligenceTimelineItemResponseEventKind)[keyof typeof BuildingIntelligenceTimelineItemResponseEventKind];

export const BuildingIntelligenceTimelineItemResponseEventKind = {
    issueDate: 'IssueDate',
    expiryDate: 'ExpiryDate',
} as const;
